import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, supportedLanguages } from "./translations";

const LanguageContext = createContext({
  lang: "lv",
  setLang: () => {},
  t: (path) => path,
});

const STORAGE_KEY = "roze-lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "lv";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && supportedLanguages.includes(stored)) return stored;
    const nav = (window.navigator?.language || "lv").slice(0, 2);
    return supportedLanguages.includes(nav) ? nav : "lv";
  });

  const setLang = (next) => {
    if (!supportedLanguages.includes(next)) return;
    setLangState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, next);
    }
  };

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useMemo(() => {
    const dict = translations[lang] || translations.lv;
    return (path) => {
      const segments = path.split(".");
      let cur = dict;
      for (const s of segments) {
        if (cur == null) return path;
        cur = cur[s];
      }
      return cur === undefined ? path : cur;
    };
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
